import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@Shared/components/general/page-header";
import TableLoader from "./referrer-list-loader.vue";
import RowLoader from "./referrer-row-loader.vue";
import Icon from "@Shared/components/general/fa-icon";
import { LOAD_REFERRERS, CREATE_REFERRER } from "../../store/referrer-actions";
import { REFERRERS_LOADED, GET_CURRENT_FILTERS, GET_CURRENT_REFERRERS } from "../../store/referrer-getters";
import { mapActions, mapState, mapGetters } from "vuex";
import ReferrerListActions from "./referrer-list-actions.vue";
import ManageReferrerModal from "../manage-referrer-modal.vue";
import ReferrersTable from "./referrers-table.vue";
import { Event } from "@alexrafael10/vue-tables-2";
import { showToast } from "@Shared/@Utils/constants";
import Amplitude from "@Shared/@Utils/amplitude";
import { debounce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrersListContainer",
  title() {
    return this.$t("sidebar.sections.referrers");
  },
  components: {
    TableLoader,
    RowLoader,
    Icon,
    PageHeader,
    ReferrerListActions,
    ManageReferrerModal,
    ReferrersTable
  },
  data() {
    return {
      loading: true,
      loadingReferrers: false,
      loadingTable: false,
      creatingReferrer: {
        loading: false,
        status: false
      },
      searchString: "",
      DEFAULT_LIMIT: 20,
      SCROLL_OFFSET: 200
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("ReferrerStore", ["totalReferrers"])), mapGetters("ReferrerStore", [REFERRERS_LOADED, GET_CURRENT_FILTERS, GET_CURRENT_REFERRERS])), {}, {
    tableSummaryText() {
      if (this.totalReferrers) return this.$t("tables.filters.showingOutOf", {
        current: this.REFERRERS_LOADED,
        total: this.totalReferrers
      });
      if (!this.GET_CURRENT_REFERRERS && this.currentFilters) return this.$t("referrers.messages.filterReferrersNoMatch");
      return this.$t("tables.messages.emptyReferrers");
    },
    currentFilters() {
      const {
        type
      } = this.GET_CURRENT_FILTERS;
      const filters = [];
      if (type) filters.push({
        text: this.$t(`referrers.referrerType.${type}`),
        variation: "30",
        filter: "type"
      });
      return filters.length ? filters : null;
    }
  }),
  watch: {
    searchString(val) {
      // if val is less than 3 chars, no search is done
      //eslint-disable-next-line vue/custom-event-name-casing
      Event.$emit("vue-tables.filter::fullname", val.length < 3 ? "" : val);
    }
  },
  beforeDestroy() {
    document.getElementById("page").removeEventListener("scroll", debounce(this.handleScroll, 100));
  },
  mounted() {
    Amplitude.logEvent("Referrers - visited");
    this.init();
    document.getElementById("page").addEventListener("scroll", debounce(this.handleScroll, 100));
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [LOAD_REFERRERS, CREATE_REFERRER])), {}, {
    handleOpenAddReferrerModal() {
      this.$refs.addReferrerModal.showModal();
    },
    async init() {
      this.loading = true;
      this.searchString = this.GET_CURRENT_FILTERS.searchString;
      await this.LOAD_REFERRERS({
        limit: this.DEFAULT_LIMIT
      });
      this.loading = false;
    },
    async handleCreateReferrer({
      referrer
    }) {
      try {
        this.creatingReferrer.loading = true;
        await this.CREATE_REFERRER({
          referrer
        });
        showToast("success", "referrerCreated");
        this.creatingReferrer.status = true;
        this.$refs.addReferrerModal.hideModal();
      } catch (_unused) {
        this.creatingReferrer.status = false;
      } finally {
        this.creatingReferrer.loading = false;
      }
    },
    handleScroll(event) {
      const scroller = event.target;
      if (scroller.scrollTop + scroller.clientHeight + this.SCROLL_OFFSET >= scroller.scrollHeight) {
        if (this.totalReferrers > this.REFERRERS_LOADED && !this.loadingReferrers) {
          this.loadMoreReferrers();
        }
      }
    },
    async loadMoreReferrers() {
      this.loadingReferrers = true;
      await this.LOAD_REFERRERS({
        offset: this.REFERRERS_LOADED
      });
      this.loadingReferrers = false;
    },
    async handleSort({
      orderBy,
      orderType
    }) {
      this.loadingTable = true;
      await this.LOAD_REFERRERS({
        limit: this.REFERRERS_LOADED,
        orderBy,
        orderType
      });
      this.loadingTable = false;
    },
    async searchReferrer(searchString) {
      this.loadingTable = true;
      await this.LOAD_REFERRERS({
        searchString
      });
      this.loadingTable = false;
    },
    async handleFilter(data) {
      this.loadingTable = true;
      await this.LOAD_REFERRERS(_objectSpread({}, data));
      this.loadingTable = false;
    },
    async clearFilter(data) {
      this.loadingTable = true;
      await this.LOAD_REFERRERS({
        [data]: null
      });
      this.$refs.referrerActions.clearFilter(data);
      this.loadingTable = false;
    }
  })
});